import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supportUserContext } from 'application/contexts/useSupportUser';
import { diContainerContext } from 'application/contexts/useDiContainer';
import { SupportUserLogout } from 'application/usecases/SupportUserLogout';

export const useHeader = () => {
    const navigate = useNavigate();
    const diContainer = useContext(diContainerContext);
    const supportUserLogout = diContainer.resolve(SupportUserLogout);

    const { user, resetUser } = useContext(supportUserContext);
    const [popoverOpen, setPopoverOpen] = useState(false);

    const handleLogout = async () => {
        await supportUserLogout.execute();
        window.location.href = '/supporter/login/';
        resetUser();
    };

    const menuItems = [
        { text: 'マイページ', url: '/supporter/dashboard/' },
        { text: 'ログアウト', url: '/supporter/login/', handler: handleLogout },
    ];

    const onItemClick = (item: (typeof menuItems)[0]) => {
        setPopoverOpen(false);
        item.handler?.();
        if (item.url) navigate(item.url);
    };

    return {
        user,
        popoverOpen,
        setPopoverOpen,
        menuItems,
        onItemClick,
    };
};
